import React, { ChangeEvent, useState } from "react";
import {
  Box,
  Button,
  CardMedia,
  Input,
  TextField,
  Tooltip,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import CloseIcon from "@mui/icons-material/Close";
import EditIcon from "@mui/icons-material/Edit";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import VerifiedIcon from '@mui/icons-material/Verified';
const ManageProfile = () => {
  const navigate = useNavigate();
  const [image, setImage] = useState<string>("");
  const [fileName, setFileName] = useState<string>("");
  const [startDate, setStartDate] = useState<any>(null);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    navigate("/dashboard");
  };

  return (
    <>
      <div className="main_title">
        <h1>Manage Profile</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Profile
        </p>
      </div>

      <div className="cards view_page profile_page_tab">
        <div className="table_header">
          <div className="left_s">
            <h2></h2>
          </div>
          <div className="right_s">
            <Button className="btn btn_primary">
              <EditIcon /> Edit Information
            </Button>
          </div>
        </div>

        <form className="form" onSubmit={handleSubmit}>
          <div className="gap_p">
            {/* 🔹 Upload Image */}
            <div className="control_group w_100">
              <label htmlFor="icon-button-file">Upload Image</label>
              {image ? (
                <div className="upload_image">
                  <div className="upload_image_holder">
                    <figure>
                      <CardMedia component="img" image={image} alt="photo" />
                    </figure>
                    <CloseIcon
                      onClick={() => {
                        setImage("");
                        setFileName("");
                      }}
                    />
                  </div>
                </div>
              ) : (
                <label className="upload_image" htmlFor="icon-button-file">
                  <Input
                    sx={{ display: "none" }}
                    id="icon-button-file"
                    type="file"
                    inputProps={{
                      accept: "image/png,image/jpeg",
                    }}
                    onChange={(event: ChangeEvent<HTMLInputElement>) => {
                      const files = (event.target as HTMLInputElement).files;
                      if (files && files[0].type.includes("image")) {
                        setFileName(files[0].name);
                        setImage(URL.createObjectURL(files[0]));
                      } else {
                        alert("This field only accepts images.");
                      }
                    }}
                  />
                  <span className="upload_image_holder">
                    <figure className="add_img">
                      <img
                        src="/static/images/user_placeholder.png"
                        alt="icon"
                      />
                      <span className="upload_img_icon">
                        <img src="/static/images/edit2_icon.svg" alt="icon" />
                      </span>
                      <span className="badge">
                        <Tooltip title="This seller earned the Supporter Badge by referring new customers to Bouteek. It reflects their active contribution to the community and strong marketplace engagement.">
                          <VerifiedIcon />
                        </Tooltip>
                      </span>
                    </figure>
                  </span>
                </label>
              )}
            </div>

            {/* 🔹 User Info Fields */}
            <div className="control_group w_33">
              <label htmlFor="ownerName">Owner Name</label>
              <TextField
                id="ownerName"
                name="ownerName"
                placeholder="Enter Name"
                fullWidth
              />
            </div>

            <div className="control_group w_33">
              <label htmlFor="email">Email</label>
              <TextField
                id="email"
                name="email"
                placeholder="Enter Email"
                fullWidth
              />
            </div>

            <div className="control_group w_33">
              <label htmlFor="phone">Contact Phone</label>
              <TextField
                id="phone"
                name="phone"
                placeholder="Enter Phone Number"
                fullWidth
              />
            </div>

            {/* 🔹 Date of Birth */}
            <div className="control_group w_33">
              <label>Date of Birth</label>
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                  value={startDate}
                  onChange={(newValue) => setStartDate(newValue)}
                  slotProps={{
                    textField: {
                      placeholder: "Select Date of Birth",
                      fullWidth: true,
                    },
                  }}
                />
              </LocalizationProvider>
            </div>

            {/* 🔹 Save Button */}
            <div className="form_btn">
              <Button className="btn btn_primary" variant="contained" type="submit">
                Save
              </Button>
            </div>
          </div>
        </form>
      </div>
    </>
  );
};

export default ManageProfile;
